export const ELEMENT_VMODAL_ID = "AUTH_VMODAL_ID";
